export default "__VITE_ASSET__JSo$3t7$__"